<template>
    <div class="card shadow-sm mb-5 p-5 card-flush overflow-hidden h-md-100">
      <button v-if="remove"
          type="button"
          class="btn-close position-absolute top-0 end-0 mt-2 me-4"
          aria-label="Remove"
          @click="remove"/>

        <div class="card-header">
          <div class="card-title">
              <h5 style="text-align: start">{{ title }}</h5>
          </div>
            
        </div>
        <Loader :is-loading="loading">
          <div class="card-body d-flex text-center justify-content-center flex-column px-0">
            <div v-if="!topClients?.length" class="text-center">
              <img src="@/assets/media/pos/Empty2.png" alt="" class="mw-100 h-150px" />
              <div class="text-gray-400 fs-4 fw-bold">{{ $t('no_data_found') }}</div>
              <div class="text-gray-700 fs-4 fw-bold">{{title }}</div>
            </div>
            <div v-if="topClients?.length" class="p-5">
              <div class="row">
                <canvas id="kt_chartjs_top_clients" class="mh-200px"></canvas>
              </div>
            </div>
          </div>
        </Loader>
    </div>  
</template>
<script setup>
import {  shallowRef,onMounted, ref} from 'vue';
import { useStore } from 'vuex';
import { computed, watch } from 'vue';
import Loader from '@/components/Loader.vue';

const store = useStore()

const props = defineProps({
  id:{type: String, required: true},
  title:{type: String, required: true},
  loading:{type: Boolean, default: false},
  loadStats:{type: Function, required: true},
  remove:{type: Function},
  start: { type: Date, required: false },
  end: { type: Date, required: false },

})
  
const query = ref({
    start_date: '',
    end_date: '',
    
})

const topClients = ref([])
const chartTopClientRef = shallowRef(null)

const defaultCurrency = computed(() => store.getters['company/getCompanyCurrency'])

watch(() => query.value, () => {
  if (query.value.start_date && query.value.end_date) {
    loadData();
  }
}, {deep: true})


watch(() => [props.start, props.end], () => {
 if(props.start) query.value.start_date = props.start
 if(props.end) query.value.end_date = props.end
})


function loadData(){
  if (!query.value.start_date || !query.value.end_date) {
    console.warn("Dates non définies, loadData ignorée");
    return;
  }
  if(isSafe(query.value.start_date) && isSafe(query.value.end_date)){
     Promise.all([
       props.loadStats({id:props.id,startDate: query.value.start_date, endDate: query.value.end_date}).then((res) => {
          topClients.value = res?.data?.topCustomer || res?.response?.data;


        }),  
    ]).then(() => {
      chartTopClient()
    }) 
  }
    
}

function chartTopClient() {
  const ctx = document.getElementById('kt_chartjs_top_clients')
  if(ctx){
    if(Chart.getChart("kt_chartjs_top_clients")) {
      Chart.getChart("kt_chartjs_top_clients")?.destroy()
    }

    let context = ctx.getContext('2d');

  
    const data = []
      topClients.value?.forEach(item => {
        data.push({
          name: item.name,
          amount: item.total_paid
        })
      })

    let config = {
      type: 'bar',
      data: {
        labels: data.map(item => item.name),
        datasets: [{
          label: i18n.global.t('invoices.top_clients'),
          data: data.map(item => item.amount),
          backgroundColor: data.map(item => '#0072CE'),
          borderColor: data.map(item => '#0056A1'),
          borderRadius: 10,
          borderWidth: 1
        }]
      },
      options: {
        responsive: true,
        plugins: {
          tooltip: {
            callbacks: {
              label: function(context) {
                return `${context.label}: ${$formatLocalAmount(context.raw)} ${defaultCurrency.value?.symbol}`;
              }
            }
          }
        },
        scales: {
          x: {
            stacked: true,
            grid: {
              display: false
            }
          },
          y: {
            stacked: true,
            beginAtZero: true
          }
        }
      }
    };

    if (!chartTopClientRef.value) {
      chartTopClientRef.value = new Chart(ctx, config);
    }else{
      chartTopClientRef.value.destroy()
      chartTopClientRef.value = new Chart(ctx, config);
    }
  }
}

  
onMounted(() => {
 if(props.start) query.value.start_date = props.start
 if(props.end) query.value.end_date = props.end
})

function isSafe(date){
  if(!date || date === undefined )
    return false

  return true
}
</script>